<template>
  <v-dialog width="500px" :value="value" @input="toggleModal()" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbPink" dark flat>
        <div class="text-h6">
          {{ method === 'edit' ? $t('general.editRol') : $t('general.newRol') }}
        </div>
        <v-spacer />
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12" class="pt-6 pb-0">
              <v-text-field :label="$t('general.name')"
                            background-color="kbWhite"
                            color="kbDarkBlueText"
                            :rules="[rules.required]"
                            solo
                            v-model="roleForm.name">
              </v-text-field>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-text-field :label="$t('general.code')"
                            background-color="kbWhite"
                            color="kbDarkBlueText"
                            :rules="[rules.required]"
                            solo
                            v-model="roleForm.code">
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="mr-2"
               color="red"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="kbPink"
               dark
               :loading="loadingSubmit"
               @click="submit()">
          {{ method === 'edit' ? $t('general.save') : $t('general.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import arraysAndJsonsHelpers from '@/libs/arraysAndJsonsHelpers'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  data () {
    return {
      loadingSubmit: false,
      roleForm: {
        name: '',
        code: ''
      },
      rules
    }
  },
  methods: {
    clearForm () {
      this.$refs.form.reset()
      this.roleForm = {
        name: '',
        code: ''
      }
    },
    async createRole () {
      await this.$store.dispatch('createRol', this.roleForm)
      notifications.success(this.$t('general.rolSuccessfullyCreated'))
      this.toggleModal()
    },
    setLocalRole () {
      this.roleForm = arraysAndJsonsHelpers.copyJson(this.selectedRole)
    },
    async submit () {
      try {
        if (this.loadingSubmit || !this.$refs.form.validate()) return
        this.loadingSubmit = true
        this.method === 'edit' ? await this.updateRole() : await this.createRole()
      } catch (e) {
        notifications.error(e)
      } finally {
        this.loadingSubmit = false
      }
    },
    toggleModal () {
      this.clearForm()
      this.$emit('input', false)
    },
    async updateRole () {
      await this.$store.dispatch('updateRol', {
        roleId: this.selectedRole.id,
        name: this.roleForm.name,
        code: this.roleForm.code
      })
      notifications.success(this.$t('general.rolSuccessfullyEdited'))
      this.toggleModal()
    }
  },
  props: {
    method: {
      type: String,
      default: 'create',
      validators: (value) => {
        return ['create', 'edit'].indexOf(value) !== -1
      }
    },
    selectedRole: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (value) {
      if (value && this.method === 'edit') {
        this.setLocalRole()
      }
    }
  }
}
</script>
